export const UBC_COMMERCIAL_LIST_STATE_NAME = 'ubc-commercial-list';
